// ============================================================================
// PORTUGUESE TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// Perguntas reflexivas e interessantes sobre a fé

export const funQuestions = [
  {
    question: "Qual ato de amor de Jesus mais te inspira em sua vida diária?",
    emoji: "❤️",
    theme: "amor"
  },
  {
    question: "Se você pudesse compartilhar uma refeição com um personagem bíblico, quem seria e por quê?",
    emoji: "🍞",
    theme: "encontro"
  },
  {
    question: "Qual parábola de Jesus fala mais profundamente com você e por quê?",
    emoji: "🌱",
    theme: "ensinamento"
  },
  {
    question: "Como a paz de Deus se manifesta em sua vida?",
    emoji: "🕊️",
    theme: "paz"
  },
  {
    question: "Qual milagre de Jesus você gostaria de ter presenciado?",
    emoji: "✨",
    theme: "fé"
  },
  {
    question: "Se você tivesse que descrever o amor de Deus em uma palavra, qual seria?",
    emoji: "💝",
    theme: "amor divino"
  },
  {
    question: "Qual versículo da Bíblia te ajudou em um momento difícil?",
    emoji: "📖",
    theme: "consolo"
  },
  {
    question: "Como você pode ser luz do mundo hoje?",
    emoji: "💡",
    theme: "testemunho"
  }
];

export default funQuestions;
